import { render, staticRenderFns } from "./CodeReveralIot.vue?vue&type=template&id=87ca85d6&scoped=true"
import script from "./CodeReveralIot.vue?vue&type=script&lang=js"
export * from "./CodeReveralIot.vue?vue&type=script&lang=js"
import style0 from "./CodeReveralIot.vue?vue&type=style&index=0&id=87ca85d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca85d6",
  null
  
)

export default component.exports